// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1FM47","title":"Info_title__-gd80","selects":"Info_selects__1ILPE","requiredAsterisk":"Info_requiredAsterisk__1nuUN"};